const API_V1_PREFIX = '/v1';
const API_PUBLIC_PREFIX = '/v1/public';

export const API_ROUTES = {
  // Content routes
  CONTENT: `${API_V1_PREFIX}/content`,
  CONTENT_BY_KEY: (key: string) => `${API_V1_PREFIX}/content/${key}`,

  // Product routes
  PRODUCTS: `${API_V1_PREFIX}/products`,
  PRODUCT_BY_ID: (id: string) => `${API_V1_PREFIX}/products/${id}`,

  // Service routes
  SERVICES: `${API_V1_PREFIX}/services`,
  SERVICE_BY_ID: (id: string) => `${API_V1_PREFIX}/services/${id}`,

  // FAQ routes
  FAQS: `${API_V1_PREFIX}/faqs`,
  FAQS_BY_TYPE: (type: 'piercing' | 'tattoo') => `${API_V1_PREFIX}/faqs/type/${type}`,
  FAQ_BY_ID: (id: string) => `${API_V1_PREFIX}/faqs/${id}`,

  // Flash routes
  FLASHES: `${API_V1_PREFIX}/flashes`,
  FLASH_BY_ID: (id: string) => `${API_V1_PREFIX}/flashes/${id}`,

  // Tattoo image routes
  TATTOO_IMAGES: `${API_V1_PREFIX}/tattoo-images`,
  TATTOO_IMAGE_BY_ID: (id: string) => `${API_V1_PREFIX}/tattoo-images/${id}`,

  // Hero routes
  HEROES: `${API_V1_PREFIX}/heroes`,
  HERO_BY_TYPE: (type: 'piercing' | 'tattoo') => `${API_V1_PREFIX}/heroes/type/${type}`,
  HERO_BY_ID: (id: string) => `${API_V1_PREFIX}/heroes/${id}`,

  // Meeting routes (authenticated - for admin)
  MEETINGS: `${API_V1_PREFIX}/meetings`,
  MEETING_BY_ID: (id: string) => `${API_V1_PREFIX}/meetings/${id}`,
  MEETINGS_TODAY: `${API_V1_PREFIX}/meetings/today`,
  MEETINGS_DATE_RANGE: `${API_V1_PREFIX}/meetings/date-range`,

  // Public meeting routes (for web public access)
  PUBLIC_MEETINGS: `${API_PUBLIC_PREFIX}/meetings`,
  PUBLIC_MEETINGS_FROM_TODAY: `${API_PUBLIC_PREFIX}/meetings/from-today`,
  PUBLIC_MEETINGS_OCCUPIED_SLOTS: `${API_PUBLIC_PREFIX}/meetings/occupied-slots`,
  PUBLIC_MEETING_BY_ID: (id: string) => `${API_PUBLIC_PREFIX}/meetings/${id}`,
  PUBLIC_MEETING_CANCEL: (id: string) => `${API_PUBLIC_PREFIX}/meetings/${id}/cancel`,

  // Client routes (authenticated)
  CLIENTS: `${API_V1_PREFIX}/clients`,
  CLIENT_BY_ID: (id: string) => `${API_V1_PREFIX}/clients/${id}`,

  // Project routes (authenticated)
  PROJECTS: `${API_V1_PREFIX}/projects`,
  PROJECT_BY_ID: (id: string) => `${API_V1_PREFIX}/projects/${id}`,

  // Public project routes (for web public access)
  PUBLIC_PROJECTS: `${API_PUBLIC_PREFIX}/projects`,
  PUBLIC_PROJECT_CREATE: `${API_V1_PREFIX}/projects/public`,
  PUBLIC_PROJECT_BY_ID: (id: string) => `${API_V1_PREFIX}/projects/${id}/public`,

  // Project status routes
  PROJECT_STATUSES: `${API_V1_PREFIX}/project-statuses`,

  // Financial routes (authenticated)
  FINANCIALS: `${API_V1_PREFIX}/financials`,
  FINANCIAL_BY_ID: (id: string) => `${API_V1_PREFIX}/financials/${id}`,
} as const;
